import CookieConsentBanner from './components/CookieConsentBanner';
import { Whatsapp } from './components/whatsapp'
import Router from './router/index'



function App() {

  return (
    <>
      <Router />
      <Whatsapp />  
      <CookieConsentBanner />  
    </>
  );
}

export default App;